export default function() {
  const widgetName = 'locationsButton';
  const widgetOpts = locationsButtonOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      const widget = $(`#${widgetName}`);
      if(data.items.length < 1) {
        widget.remove();
        return;
      }
      widget.find('.card-widget-item').addClass('button')
      $('.services').append(widget);
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}